<template>
    <div>
        <form-group type="text"
                    label="Slug"
                    id="slug"
                    v-model="form.slug"
                    :error="form.errors.get('slug')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    label="Name"
                    id="name"
                    v-model="form.name"
                    :error="form.errors.get('name')"
                    @event="form.listen(form, $event)">
        </form-group>

        <button type="button" class="button is-primary" @click="submit()">Save</button>
    </div>
</template>

<script>
    import Form from "../../helpers/Form"
    import {mapGetters} from "vuex"
    import {CREATE_TAG, UPDATE_TAG} from "../../store/mutation-types"
    export default {
        props: {
            tag: {
                type: [String, Object], default: () => {
                    return {
                        slug: '',
                        name: '',
                        description: '',
                    }
                }
            },
            create: {type: [Boolean], default: false}
        },
        data() {
            return {
                form: new Form(this, this.tag, this.create ? CREATE_TAG : UPDATE_TAG)
            }
        },
        methods: {
            submit() {
                this.form.submit().then(data => {
                    this.$emit('saved', data)
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// TagForm.vue?456fe9a4